export function convertNotaryToFields(notary) {
  const fields = [];

  if (!notary) {
    return fields;
  }

  const notaryData = notary;

  // Маппинг полей нотариуса - используем ключи БЕЗ префикса "notary_"
  const fieldMappings = [
    {
      templateKey: "iin",
      notaryKey: "identifier",
      value: notaryData.identifier,
    },
    {
      templateKey: "uuid",
      notaryKey: "uuid",
      value: notaryData.uuid,
    },

    {
      templateKey: "last_name",
      notaryKey: "last_name",
      value: notaryData.last_name,
    },
    {
      templateKey: "first_name",
      notaryKey: "first_name",
      value: notaryData.first_name,
    },
    {
      templateKey: "middle_name",
      notaryKey: "middle_name",
      value: notaryData.middle_name,
    },

    {
      templateKey: "fio",
      notaryKey: "full_name",
      value: `${notaryData.last_name || ""} ${notaryData.first_name || ""} ${
        notaryData.middle_name || ""
      }`.trim(),
    },
    {
      templateKey: "previous_fio",
      notaryKey: "previous_full_name",
      value: notaryData.previous_full_name,
    },

    {
      templateKey: "email",
      notaryKey: "email",
      value: notaryData.email,
    },
    {
      templateKey: "phone",
      notaryKey: "work_phone",
      value: notaryData.work_phone,
    },

    {
      templateKey: "license_number",
      notaryKey: "license_number",
      value: notaryData.license_number,
    },
    {
      templateKey: "license_issue_date",
      notaryKey: "license_issue_date",
      value: notaryData.license_issue_date,
    },
    {
      templateKey: "license_status",
      notaryKey: "license_status",
      value: notaryData.license_status,
    },

    {
      templateKey: "education_institution",
      notaryKey: "education_institution",
      value: notaryData.education_institution,
    },
    {
      templateKey: "education_specialty",
      notaryKey: "education_specialty",
      value: notaryData.education_specialty,
    },
    {
      templateKey: "education_diploma_number",
      notaryKey: "education_diploma_number",
      value: notaryData.education_diploma_number,
    },

    {
      templateKey: "registration_date",
      notaryKey: "registration_date",
      value: notaryData.registration_date,
    },
    {
      templateKey: "chamber_join_date",
      notaryKey: "chamber_join_date",
      value: notaryData.chamber_join_date,
    },

    {
      templateKey: "status",
      notaryKey: "status",
      value: notaryData.status,
    },
  ];

  fieldMappings.forEach((mapping) => {
    if (
      mapping.value !== undefined &&
      mapping.value !== null &&
      mapping.value !== ""
    ) {
      const stringValue = String(mapping.value).trim();
      if (stringValue) {
        fields.push({
          key: mapping.templateKey, // Ключ БЕЗ префикса "notary_"
          value: stringValue,
          participant_type_code: "",
          service_code: "notary",
          display_name: getDisplayName(mapping.templateKey),
        });
      }
    }
  });

  return fields;
}

export function getDisplayName(fieldKey) {
  const displayNames = {
    iin: "ИИН нотариуса",
    uuid: "UUID нотариуса",
    last_name: "Фамилия нотариуса",
    first_name: "Имя нотариуса",
    middle_name: "Отчество нотариуса",
    fio: "ФИО нотариуса",
    previous_fio: "Предыдущее ФИО нотариуса",
    email: "Email нотариуса",
    phone: "Телефон нотариуса",
    license_number: "Номер лицензии нотариуса",
    license_issue_date: "Дата выдачи лицензии",
    license_status: "Статус лицензии",
    education_institution: "Учебное заведение нотариуса",
    education_specialty: "Специальность нотариуса",
    education_diploma_number: "Номер диплома нотариуса",
    registration_date: "Дата регистрации нотариуса",
    chamber_join_date: "Дата вступления в палату",
    status: "Статус нотариуса",
  };

  return displayNames[fieldKey] || fieldKey;
}
